/* eslint-disable react/jsx-filename-extension */

import React from 'react';
import { PreviewStoreProvider } from 'gatsby-source-prismic';
import { PageContextProvider } from './src/contexts/page-context';

export const wrapRootElement = ({ element }) => {
  return <PreviewStoreProvider>{element}</PreviewStoreProvider>;
};

export const wrapPageElement = ({ element, props: { pageContext } }) => {
  return <PageContextProvider pageContext={pageContext}>{element}</PageContextProvider>;
};
